import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const MatchPlanSchema = withDefaults({
  type: 'match-plan',
  objectExtensions: ['match-plan'],
  fields: [
    {
      kind: 'attribute',
      name: 'benefitStartDate',
    },
    {
      kind: 'attribute',
      name: 'benefitWaitingPeriod',
    },
    {
      kind: 'attribute',
      name: 'benefitStartIsRetroactive',
    },
    {
      kind: 'attribute',
      name: 'code',
    },
    {
      kind: 'attribute',
      name: 'complexMatch',
    },
    {
      kind: 'attribute',
      name: 'description',
    },
    {
      kind: 'attribute',
      name: 'faqs',
    },
    {
      kind: 'attribute',
      name: 'fileDateBuffer',
    },
    {
      kind: 'attribute',
      name: 'information',
    },
    {
      kind: 'attribute',
      name: 'matchFrequencyDescription',
    },
    {
      kind: 'attribute',
      name: 'matchPercentage',
    },
    {
      kind: 'attribute',
      name: 'matchStatement',
    },
    {
      kind: 'attribute',
      name: 'maxMatchCap',
    },
    {
      kind: 'attribute',
      name: 'maxMatchPercentage',
    },
    {
      kind: 'attribute',
      name: 'metadata',
    },
    {
      kind: 'attribute',
      name: 'minimumThresholdPercentage',
    },
    {
      kind: 'attribute',
      name: 'periodBuffer',
    },
    {
      kind: 'attribute',
      name: 'periodCadence',
    },
    {
      kind: 'attribute',
      name: 'periodNamingScheme',
    },
    {
      kind: 'attribute',
      name: 'planName',
    },
    {
      kind: 'attribute',
      name: 'qualifyingIncome',
    },
    {
      kind: 'attribute',
      name: 'requiresEmployeeCertification',
    },
    {
      kind: 'attribute',
      name: 'showInsights',
    },
    {
      kind: 'attribute',
      name: 'verifyAccountStatement',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'updatedAt',
    },
    {
      kind: 'belongsTo',
      name: 'company',
      type: 'company',
      options: {
        async: false,
        inverse: 'matchPlans',
      },
    },
    {
      kind: 'hasMany',
      name: 'matchPeriods',
      type: 'match-period',
      options: {
        async: false,
        inverse: 'matchPlan',
      },
    },
  ],
});

export default MatchPlanSchema;
